import React, {useEffect, useState} from 'react';
import {useReactToPrint} from "react-to-print";
import {makeStyles} from '@material-ui/core/styles';
import SpeedDial from '@material-ui/lab/SpeedDial';
import SpeedDialIcon from '@material-ui/lab/SpeedDialIcon';
import SpeedDialAction from '@material-ui/lab/SpeedDialAction';
//import jsPDF from "jspdf";
//import FileCopyIcon from '@material-ui/icons/FileCopyOutlined';
//import SaveIcon from '@material-ui/icons/Save';
import PrintIcon from '@material-ui/icons/Print';
//import ShareIcon from '@material-ui/icons/Share';
import JsonScreenHoc from "../../../HocHelpers/JsonScreenHoc";

const useStyles = makeStyles((theme) => ({
    root: {
        transform: 'translateZ(0px)',
        flexGrow: 1,
    },
    exampleWrapper: {
        position: 'relative',
        marginTop: theme.spacing(1),
        width: 60
    },
    radioGroup: {
        margin: theme.spacing(1, 0),
    },
    speedDial: {
        position: 'absolute',
        '&.MuiSpeedDial-directionDown, &.MuiSpeedDial-directionRight': {
            top: theme.spacing(0),
            left: 0
        },
    },
    fabComponent: {
        height: 36,
        width: 36
    }
}));

const ReportMenu = ({screenRef, screenValues, ...props}) => {
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const [actions, setActions] = useState([]);
    const printAction = useReactToPrint({
        content: () => screenRef.current,
    });
    // const savePdfAction = () => {
    //     const {screen: {properties}} = props;
    //     const unit = "pt";
    //     const doc = new jsPDF(properties.orientation, unit, properties.size);
    //     doc.fromHTML(screenRef.current);
    //     doc.save('sample.pdf')
    // };
    useEffect(() => {
        setActions([
                // {icon: <FileCopyIcon/>, name: 'Copy'},
                // {icon: <SaveIcon/>, name: 'Save', doAction: savePdfAction},
                {icon: <PrintIcon/>, name: 'Print', doAction: printAction}]
            // { icon: <ShareIcon />, name: 'Share' }]
        )
    }, [screenRef]);
    const handleClose = () => {
        setOpen(false);
    };
    const handleOpen = () => {
        setOpen(true);
    };
    return (
        <div className={classes.exampleWrapper}>
            <SpeedDial
                ariaLabel="Report SpeedDial"
                className={classes.speedDial}
                classes={{fab: classes.fabComponent}}
                icon={<SpeedDialIcon/>}
                onClose={handleClose}
                onOpen={handleOpen}
                open={open}
                direction={'down'}
            >
                {actions.map((action) => (
                    <SpeedDialAction
                        key={action.name}
                        icon={action.icon}
                        tooltipTitle={action.name}
                        onClick={action.doAction}
                    />
                ))}
            </SpeedDial>
        </div>
    )
};

export default JsonScreenHoc(ReportMenu)